import { useState } from 'react';
import GroupedDropdown from '@components/groupedDropdown';
import { Popover, CaretdownIcon, ClearIcon } from '@components/componentUtils';
import { inputClasses, normalizeText } from '@components/utils';
import get from 'lodash.get';

function capitalizeFirstLetter(inputString) {
  return String(inputString).charAt(0).toUpperCase() + String(inputString).slice(1);
}

export function Templates({ buttonComponent, templates = [], onSelectTemplate }) {
  const [keyword, setKeyword] = useState('');

  const groups =
    templates &&
    Array.isArray(templates) &&
    Object.values(
      templates.reduce((acc, template) => {
        const id = get(template, 'suggest_for_model.id', 'default');
        const currentGroup = acc[id];
        const currentGroupValues = get(currentGroup, 'items', []) || [];
        const newGroupValues = [...currentGroupValues, template];

        acc[id] = {
          label: get(template, 'suggest_for_model.label', 'Non classé'),
          id,
          items: newGroupValues
        };
        return acc;
      }, {})
    )
      .sort((a, b) => {
        if (a.label === 'Non classé') return 1;
        if (b.label === 'Non classé') return -1;

        const labelA = a.label.toUpperCase();
        const labelB = b.label.toUpperCase();

        if (labelA < labelB) {
          return -1;
        }

        if (labelA > labelB) {
          return 1;
        }

        return 0;
      })
      .map(group => {
        if (keyword.length >= 1) {
          const safeKeyword = normalizeText(keyword);
          const filteredItems = get(group, 'items', []).filter(item => {
            const normalizedText = normalizeText(item.label);
            return normalizeText(item.label).includes(safeKeyword);
          });

          if (filteredItems.length >= 1) {
            return { ...group, items: filteredItems };
          } else {
            return false;
          }
        } else {
          return group;
        }
      })
      .filter(Boolean);

  return (
    <Popover
      width="w-[400px]"
      padding="p-4 pb-0"
      buttonComponent={
        buttonComponent || (
          <div
            type="button"
            className="font-hmedium text-xs rounded-full bg-blue-50 text-blue-600 py-1 px-2 flex items-center space-x-2 [&_svg]:w-4 [&_svg]:h-4"
          >
            <CaretdownIcon />
            <span>Sélectionner un modèle</span>
          </div>
        )
      }
    >
      {({ setIsOpen }) => (
        <div className="pb-4 relative">
          <div className="mb-4 sticky top-0 left-0 right-0 flex">
            <input
              onChange={e => setKeyword(e.target.value)}
              type="text"
              value={keyword}
              placeholder="Rechercher..."
              className={`${inputClasses} text-base rounded-lg`}
            />
            {keyword.length >= 1 && (
              <button
                type="button"
                className="absolute right-4 top-2"
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  setKeyword('');
                }}
              >
                <ClearIcon />
              </button>
            )}
          </div>
          <div>
            {groups.map(group => {
              return (
                <div>
                  <div className="font-hmedium text-sm border-t border-b bg-slate-50 py-1 px-2">
                    {capitalizeFirstLetter(group.label)}
                  </div>
                  <div className="py-2">
                    {get(group, 'items', []).map(item => {
                      return (
                        <button
                          onClick={() => {
                            if (onSelectTemplate) {
                              onSelectTemplate(item.description);
                            }

                            setIsOpen(false);
                          }}
                          className="text-xs px-2 w-full hover:bg-slate-50 hover:text-slate-900 rounded-lg py-1"
                        >
                          {item.label}
                        </button>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </Popover>
  );
}
